import {Ability} from '~/lib/ability';

export class SupplyPackagesAbility extends Ability {
    canCreate = () => this.isAdmin();
    canEdit = () => this.isAdmin();
    canDelete = () => this.isAdmin();
}

export class DealsAbility extends Ability {
    canCreate = () => this.isAdmin();
    canEdit = () => this.isAdmin();
    canDelete = () => this.isAdmin();
}
